import React, {Component} from 'react'
import {ListItem, ListItemText, Collapse} from "@material-ui/core"
import styled from 'styled-components'
import FlexContainer from "../../content/flex"
import {List} from "../../index"
import classNames from "classnames"
import {Link} from "react-router-dom"
const Container = styled(FlexContainer.withComponent('ul'))`
        flex-flow: column;
        border-bottom: 2px solid #E6E6E6;
        & > li > div > span {
           font-size: .9rem;
        }
        &.secondary {
            &.purple {
                color: #AC5CCA;
                p {
                    font-size: 1rem;
                }
            }
            .itemToggle {
                a {
                    >div > span {
                        font-size: .75rem;
                    }
                }
            }
        }
        .itemToggle {
            padding: 0;
            a {
                >div > span {
                    font-size: 1rem;
                }
                display: flex;
                align-items: center;
                width: 100%;
                padding: 11px 24px;
            }
        }
        .subItem {
            a div > span  {
                padding-left: 1rem;
            }
        }
        
        &.list_contacts{
            height: 100%;
        }
        &.list_contacts > div, &.list_contacts > div > div , &.list_contacts > div > div > div{
            height: 100%!important;
            display: flex;
            flex-direction: column;
        }
    `
const P = styled.p`
    margin-left: auto;
    margin-right: 1rem;
    color: inherit;
    font-weight: bold;
    width: 25px;
    height: 100%;
    text-align: center;
    `
class ListToggle extends Component {
    constructor(props) {
        super(props)
        this.handleClick = this.handleClick.bind(this)
        this.state = {
            isToggleOn: false
        }
    }
    componentDidMount(){
        this.setState({isToggleOn: this.props.close})
    }
    handleClick() {
        this.setState(state => ({
            isToggleOn: !state.isToggleOn
        }));
    }

    render() {
        const {title, value,children,active,to, ...props} = this.props
        const {isToggleOn} = this.state

        return (
            <Container {...props}>
                <ListItem component="li" button className={classNames({active},"itemToggle")}>
                    <Link to={to}>
                        <ListItemText primary={title}/>
                        {value && <P>{value}</P>}
                    </Link>
                </ListItem>

                <Collapse in={isToggleOn} timeout="auto" unmountOnExit className={"toggle"}>
                    {children}
                </Collapse>
            </Container>
        )
    }
}

export default ListToggle